<ng-container *ngIf="product$ | async">
  <div>
    <custom-dot-cms-product-tile [layout]="layout" *ngIf="isTile"></custom-dot-cms-product-tile>
  </div>
</ng-container>

<ish-loading *ngIf="loading$ | async"></ish-loading>
